
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactPopup from "@/components/ContactPopup";
import BookingCalendarSection from "@/components/booking/BookingCalendarSection";
import BookingSummary from "@/components/booking/BookingSummary";
import { useBooking } from "@/hooks/useBooking";
import { PromoCodeBanner } from "@/components/home/PromoCodeBanner";
import { useTranslatedContent } from "@/hooks/useTranslatedContent";

const BookingPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  
  const initialCheckIn = queryParams.get("checkIn") 
    ? new Date(queryParams.get("checkIn") as string) 
    : undefined;
    
  const initialCheckOut = queryParams.get("checkOut") 
    ? new Date(queryParams.get("checkOut") as string) 
    : undefined;

  const {
    checkIn,
    checkOut,
    guestsCount,
    isSubmitting,
    showWaitlistDialog,
    showContactPopup,
    setShowContactPopup,
    setShowWaitlistDialog,
    appliedPromoCode,
    isValidatingPromo,
    bookingDetails,
    handleDatesSelected,
    handleSubmit,
    handleApplyPromoCode,
    handleGuestsCountChange
  } = useBooking(initialCheckIn, initialCheckOut);

  const content = {
    title: "Réserver la Villa Douce Vague"
  };

  const { translatedContent } = useTranslatedContent(content);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContactPopup(true);
    }, 15000);
    return () => clearTimeout(timer);
  }, [setShowContactPopup]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <PromoCodeBanner />
      
      <main className="flex-1 bg-villa-sand/30 pt-24 pb-16">
        <div className="section-container">
          <h1 className="heading-lg text-center text-villa-blue mb-10">
            {translatedContent.title}
          </h1>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <BookingCalendarSection
              checkIn={checkIn}
              checkOut={checkOut}
              bookingDetails={bookingDetails}
              isSubmitting={isSubmitting}
              onDatesSelected={handleDatesSelected}
              onSubmit={handleSubmit}
            />
            
            <div>
              <BookingSummary
                bookingDetails={bookingDetails ? { ...bookingDetails, guestsCount } : null}
                showWaitlistDialog={showWaitlistDialog}
                setShowWaitlistDialog={setShowWaitlistDialog}
                checkIn={checkIn}
                checkOut={checkOut}
                onDatesSelected={handleDatesSelected}
                appliedPromoCode={appliedPromoCode}
                onApplyPromoCode={handleApplyPromoCode}
                guestsCount={guestsCount}
                onGuestsCountChange={handleGuestsCountChange}
                isValidatingPromo={isValidatingPromo}
              />
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
      <ContactPopup open={showContactPopup} onOpenChange={setShowContactPopup} />
    </div>
  );
};

export default BookingPage;
